<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import axios from 'axios'
  import OssUpload from './common/OssUpload'

  export default {
    name: 'App',
    components: {},
    async beforeCreate() {
      let r = await axios.get('/admin/is-login')
      if (r.code == 121) {
        this.$router.push('/login')
      }
    },
    mounted() {
     
      this.$store.dispatch('getMenuList')
    }
  }
</script>

<style lang="stylus" scoped>
#app{
  height 100vh
  width 100vw
}

</style>



// WEBPACK FOOTER //
// src/App.vue